import React from "react";

const SubCategoryDropDown = ({
  name,
  label,
  id,
  getOptions,
  handleImageChange,
  labelStyles,
  value,
}) => {
  return (
    <div className="form-group">
      <label style={{ ...labelStyles }} htmlFor={id}>
        {label}
      </label>
      <select
        name={name}
        className="form-control form-control-sm js-example-basic-single"
        id={id}
        onChange={handleImageChange}
      >
        {value?._id ? (
          <option value={value._id}>
            {`${value?.maincategory?.name ?? ""} >  ${value?.name ?? ""} `}
          </option>
        ) : null}
        {!value?._id && <option value="">choose</option>}
        {getOptions()}
      </select>
    </div>
  );
};

export default SubCategoryDropDown;
